import {Component, inject, Input} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {PrimeTemplate} from 'primeng/api';
import {TableModule} from 'primeng/table';
import {PlayerProfileServerSettings} from '../../../../model/player-profile-server-settings';
import {PlayerProfileService} from '../../../../service/player-profile.service';
import {LoadingComponent} from '../../../../../../components/generic/loading/loading.component';
import {InfoTextComponent} from '../../../../../shared/common/info-text/info-text.component';
import {DecimalPipe} from '@angular/common';
import {FrontendNotificationService} from '../../../../../frontend/service/frontend-notification.service';

export const PLAYER_PROFILE_FEATURES = [
  { feature: 'TOURNAMENT_REGISTRATION', description: 'TOURNAMENT_REGISTRATION_TEXT', basic: true, pro: true},
  { feature: 'PLAYER_AVERAGE', description: 'PLAYER_AVERAGE_TEXT', basic: true, pro: true},
  { feature: 'AVATAR', description: 'AVATAR_TEXT', basic: true, pro: true},
  { feature: 'MY_LEAGUES', description: 'MY_LEAGUES_TEXT', basic: true, pro: true},
  { feature: 'DETAILED_STATISTICS', description: 'DETAILED_STATISTICS_TEXT', basic: false, pro: true},
  { feature: 'TOURNAMENT_CALENDAR', description: 'TOURNAMENT_CALENDAR_TEXT', basic: false, pro: true},
  { feature: 'MY_LEAGUES_CALENDAR_SYNC', description: 'MY_LEAGUES_CALENDAR_SYNC_TEXT', basic: false, pro: true},
  { feature: 'EXPORT_CALENDAR_TO_ICS', description: 'EXPORT_CALENDAR_TO_ICS_TEXT',
    basic: false, pro: true, new: new Date().getTime() < new Date(2026, 8, 30).getTime()},
  { feature: 'PUSH_NOTIFICATIONS', description: 'PUSH_NOTIFICATIONS_PLAYER_PROFILE_TEXT', basic: false, pro: true, comingSoon: false},
  { feature: 'TOURNAMENT_NOTIFICATION', description: 'TOURNAMENT_NOTIFICATION_TEXT', basic: false, pro: true},
  { feature: 'ALL_MATCHES_PLAYED', description: 'ALL_MATCHES_PLAYED_TEXT', basic: false, pro: true},
];

@Component({
  selector: 'app-player-profile-features',
  imports: [
    TranslatePipe,
    PrimeTemplate,
    TableModule,
    LoadingComponent,
    InfoTextComponent,
    DecimalPipe
  ],
  templateUrl: './player-profile-features.component.html',
  styleUrl: './player-profile-features.component.scss'
})
export class PlayerProfileFeaturesComponent
{
  public playerProfileService = inject(PlayerProfileService);
  private frontendNotificationService = inject(FrontendNotificationService);

  system = this.frontendNotificationService.system;

  // new: new Date().getTime() < new Date(2026, 7, 19).getTime()  -> Monat-Index (immer 1 Monat zurück)

  rows = PLAYER_PROFILE_FEATURES;

  @Input() onlyFeatures: boolean;

  isLoading: boolean;
  settings: PlayerProfileServerSettings;

  constructor()
  {
    this.loadData();
  }

  private loadData(): void
  {
    if (this.onlyFeatures)
      return;

    this.isLoading = true;
    this.settings = undefined;
    this.playerProfileService.loadSettings().subscribe({
      next: response =>
      {
        console.log('Einstellungen geladen', response);
        this.isLoading = false;
        this.settings = response;
      },
      error: () =>
      {
        this.isLoading = false;
      }
    });
  }
}
